"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhoneHelper = void 0;
var Validator_1 = require("../Validator");
var PhoneHelper = /** @class */ (function () {
    function PhoneHelper() {
    }
    PhoneHelper.partsOfPhoneNumber = function (number) {
        /* Check number validity */
        if (Validator_1.Validator.phone(number) !== true) {
            return null;
        }
        /* Clean the number */
        var cleanNumber = number.replace(/[. -]/g, "");
        /* Search the part and control there is a result */
        var countryCodeSearchResult = cleanNumber.match(/^\+\((\d+)\)/);
        var phoneNumberSearchResult = cleanNumber.match(/^\+\(\d+\)(\d+)$/);
        /* If invalid return */
        if (!countryCodeSearchResult || !phoneNumberSearchResult) {
            return null;
        }
        /* Extract country code */
        var countryCode = "+" + countryCodeSearchResult[1];
        /* Extract the number */
        var phoneNumber = phoneNumberSearchResult[1];
        return { countryCode: countryCode, phoneNumber: phoneNumber };
    };
    PhoneHelper.phoneNumberOfParts = function (parts) {
        /* Check parts validity */
        if (!parts || !parts.countryCode || !parts.phoneNumber) {
            return null;
        }
        /* Format the country code */
        var formattedCountryCode = "+(" + parts.countryCode.replace("+", "") + ")";
        /* Append the phoneNumber and return */
        return formattedCountryCode + parts.phoneNumber;
    };
    return PhoneHelper;
}());
exports.PhoneHelper = PhoneHelper;
//# sourceMappingURL=PhoneHelper.js.map